import React, { useState } from 'react';
import { Icon } from '../../assets/icons/Icon';
import styles from './PositiveImpactsModal.module.scss';

interface PositiveChange {
  id: string;
  name: string;
}

interface PositiveImpactsModalProps {
  isOpen: boolean;
  onClose: () => void;
  positiveChanges: PositiveChange[];
  onSelectImpact: (impactId: string) => void;
  isLoading?: boolean;
}

export const PositiveImpactsModal: React.FC<PositiveImpactsModalProps> = ({
  isOpen,
  onClose,
  positiveChanges,
  onSelectImpact,
  isLoading = false
}) => {
  const [selectedImpactId, setSelectedImpactId] = useState<string | null>(null);

  // Reset selection when modal closes
  React.useEffect(() => {
    if (!isOpen) {
      setSelectedImpactId(null);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleImpactClick = (impactId: string, e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent event bubbling
    setSelectedImpactId(impactId);
  };

  const handleSave = () => {
    if (selectedImpactId) {
      onSelectImpact(selectedImpactId);
    }
  };

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={styles.modalOverlay} onClick={handleOverlayClick}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <h2>Have you noticed any positive impacts?</h2>
          <button 
            className={styles.closeButton}
            onClick={onClose}
            aria-label="Close modal"
          >
            <Icon iconName="CrossIcon" />
          </button>
        </div>
        
        <div className={styles.content}>
          <div className={styles.impactsList}>
            {positiveChanges.map((change) => (
              <div
                key={change.id}
                className={`${styles.impactItem} ${selectedImpactId === change.id ? styles.selected : ''}`}
                onClick={(e) => handleImpactClick(change.id, e)}
              >
         
                  <Icon iconName="PositiveImpactIcon" width="1.25rem" height="1.25rem" />
                
                <span className={styles.impactText}>{change.name}</span>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.footer}>
          <button 
            className={styles.cancelButton}
            onClick={onClose}
          >
            Cancel
          </button>
          <button 
            className={`${styles.saveButton} ${!selectedImpactId ? styles.disabled : ''}`}
            onClick={handleSave}
            disabled={!selectedImpactId || isLoading}
          >
            {isLoading ? 'Saving...' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
};
